'use client';

import React from 'react';

import * as S from './style';

const NavSkip = () => (
  <S.NavSkip className="nav-skip">
    <dt>skip menu</dt>
    <dd>
      <a href="#container">본문 영역 바로가기(Go to content)</a>
    </dd>
    <dd>
      <a href="#nav-main" className="is-pc">
        메인 메뉴 영역 바로가기(Go to main menu)
      </a>
      <a href="#actionbar" className="is-mo">
        메인 메뉴 영역 바로가기(Go to main menu)
      </a>
    </dd>
    <dd>
      <a href="#footer">하단 영역 바로가기(Go to footer)</a>
    </dd>
  </S.NavSkip>
);

export default NavSkip;
